import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Routes from "./router/routes";
import "./themes/css/list-view.css";
import "./themes/css/warehouse-login.css";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
const msalInstance = new PublicClientApplication(msalConfig);


// Axios interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.reload(true);
      sessionStorage.clear(); // Clear session storage
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Routes />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
